import React from 'react';
import { Toolbar } from './components';

export function EditToolbar({ ...props }) {
  return <Toolbar {...props} />;
}
